import { FlowDiagram } from "../components/FlowDiagram";
import { Chevron, mkLink } from "../components/MkButton";

/** Where it sits: the retailer's catalog in, one assistant, every channel out, orders back. */
export function Fits() {
	return (
		<section aria-labelledby="fits-title" className="mk-section pt-0">
			<div className="mk-container">
				<div className="mk-reveal mx-auto max-w-3xl text-center">
					<h2 id="fits-title" className="mk-h2">
						It fits the systems you already run.
					</h2>
					<p className="mk-lead mt-5 text-(--mk-ink-2)">
						Your catalog comes in, orders go back. Nothing to
						rebuild, no second store to keep up to date.
					</p>
				</div>
				<FlowDiagram className="mt-14 sm:mt-16" />
				<p className="mt-10 flex flex-wrap justify-center gap-x-8 gap-y-3 text-[16px]">
					<a href="/integrations" className={mkLink()}>
						Integrations
						<Chevron />
					</a>
					<a href="/security" className={mkLink()}>
						Security and data
						<Chevron />
					</a>
				</p>
			</div>
		</section>
	);
}
